import { NewLabelChip } from 'components/chips';

export const NewLabel = () => (
  <NewLabelChip
    size="xxs"
    sx={{
      mr: 'auto',
      alignSelf: 'flex-start',
      transform: 'translateX(-8px)',

      '& > *': {
        cursor: 'inherit',
      },
    }}
  />
);
